import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const logo = this.el;
        const logoPaths = logo.querySelectorAll('path');

        gsap.from(logoPaths, {
            duration: 2,
            drawSVG: 0,
            ease: 'none',
        }, 0);
    }

    destroy() {

    }
}
